import _set from 'lodash/set'
import dayjs from 'dayjs'
import { getSubscriptionTypes } from '../../../utils/oneCodeBase'

export const audienceTypes = getSubscriptionTypes()

export const licenseTypes = {
  LICENSE_PLUS: 'LICENSE_PLUS',
  LICENSE_FREE: 'LICENSE_FREE',
  LICENSE_INACTIVE: 'LICENSE_INACTIVE'
}

class UserParser {
  constructor(CatalogsRepository) {
    this.catalogsRepository = CatalogsRepository
  }

  getLicense(license) {
    if (!license) return licenseTypes.LICENSE_FREE
    const { type = '' } = license
    if (type === audienceTypes.PLUS) {
      return licenseTypes.LICENSE_PLUS
    }
    return licenseTypes.LICENSE_FREE
  }

  getExpiration(subscription_expiration) {
    if (!subscription_expiration) return null
    if (typeof subscription_expiration === 'string')
      return dayjs(subscription_expiration).valueOf()
    if (typeof subscription_expiration === 'number')
      return subscription_expiration
    throw new Error('Unknown format for subscription_expiration')
  }

  async parseUser(fwdpUser) {
    const {
      profile_id,
      first_name,
      last_name,
      email,
      address,
      interests: originalInterests,
      language,
      subscription,
      subscription_expiration = null,
      status,
      created = null,
      updated = null,
      company,
      phone_number,
      job_title,
      job_function,
      job_function_other,
      premium_account_id,
      heard_about,
      other,
      newsletter_settings = {},
      cap,
      subscriptions = [],
      party_id = null,
      subscription_status,
      derived_company,
      license_types = [],
      access_groups = [],
      party_email_id = null
    } = fwdpUser
    const userLicense = this.getLicense(subscription)
    const interests = Object.keys(originalInterests).reduce((acc, key) => {
      const interestTree = originalInterests[key]
      if (Array.isArray(interestTree)) return { ...acc, [key]: {} }
      return {
        ...acc,
        [key]: interestTree
      }
    }, {})
    const { notify_me = [] } = newsletter_settings
    const access_group_ids = access_groups?.map(({ group_id }) => group_id)

    return {
      profile_id,
      firstName: first_name,
      lastName: last_name,
      email,
      address,
      interests,
      language,
      license: userLicense,
      expiration: this.getExpiration(subscription_expiration),
      status,
      created,
      updated: updated || created,
      company,
      job_title,
      job_function: job_function || job_function_other,
      phone_number,
      premiumAccountId: premium_account_id,
      heard_about,
      other,
      notifyMe: notify_me,
      cap,
      subscriptions,
      party_id,
      subscription_status,
      subscription_type: subscription?.type,
      derived_company,
      license_types,
      access_group_ids,
      party_email_id,
      region: 'AMER' // Default region, to be updated later based on country
    }
  }

  async buildFwdpUser(user) {
    let {
      email,
      first_name,
      last_name,
      country,
      company,
      job_title,
      job_function,
      phone_number,
      license,
      premium_account_id,
      heard_about,
      other,
      cap,
      notifySettings = null,
      fw_ai_access = false
    } = user

    const fwdpUser = {
      email,
      first_name,
      last_name,
      country,
      company,
      phone_number,
      job_title,
      subscription_type: license,
      interests: [],
      premium_account_id,
      heard_about,
      fw_ai_access,
      cap
    }
    let jobFunctionCatalog = await this.catalogsRepository.getCatalog(
      'jobFunction'
    )
    if (!jobFunctionCatalog) {
      jobFunctionCatalog = {}
    }
    const jobFunctionKey =
      Object.keys(jobFunctionCatalog).indexOf(job_function) > -1
        ? 'job_function'
        : 'job_function_other'
    _set(fwdpUser, jobFunctionKey, job_function)

    if (heard_about) {
      _set(fwdpUser, 'heard_about.from', heard_about.replace(/_/g, ' '))
      heard_about === 'other'
        ? _set(fwdpUser, 'heard_about.other', other || null)
        : _set(fwdpUser, 'heard_about.other', null)
    }

    if (notifySettings) {
      _set(fwdpUser, 'notify_me_settings', notifySettings)
    }

    return fwdpUser
  }
}

export default UserParser
